/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetUploadPlatformFeaturesQueryResponse, GetUploadPlatformFeaturesPathParams } from "../models/GetUploadPlatformFeatures";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getUploadPlatformFeatures } from "../axios/getUploadPlatformFeatures";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUploadPlatformFeaturesQueryKey = (id: GetUploadPlatformFeaturesPathParams["id"]) => ["social-export-api", { url: '/upload/:id/platform-features', params: {id:id} }] as const

export type GetUploadPlatformFeaturesQueryKey = ReturnType<typeof getUploadPlatformFeaturesQueryKey>

export function getUploadPlatformFeaturesQueryOptions(id: GetUploadPlatformFeaturesPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getUploadPlatformFeaturesQueryKey(id)
        return queryOptions<GetUploadPlatformFeaturesQueryResponse, ResponseErrorConfig<Error>, GetUploadPlatformFeaturesQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getUploadPlatformFeatures(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get available platform features for an upload
 * {@link /upload/:id/platform-features}
 */
export function useGetUploadPlatformFeatures<TData = GetUploadPlatformFeaturesQueryResponse, TQueryData = GetUploadPlatformFeaturesQueryResponse, TQueryKey extends QueryKey = GetUploadPlatformFeaturesQueryKey>(id: GetUploadPlatformFeaturesPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetUploadPlatformFeaturesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getUploadPlatformFeaturesQueryKey(id)
         

         const query = useQuery({
          ...getUploadPlatformFeaturesQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}